/* Refresh quick add: size, quantity and "Add to cart" on product cards.
   Adds the chosen variant and quantity, updates the header cart count and shows the
   add-to-cart toast (window.rfShowCartToast from product-form.js) when available. */
(function () {
  if (window.rfQuickAddReady) return;
  window.rfQuickAddReady = true;

  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

  function updateCount(count) {
    if (count === null || count === undefined) return;
    document.querySelectorAll('.cart-count-badge, #cart-details--sticky, #cart-details--relative').forEach(function (el) {
      el.textContent = count;
    });
  }

  function fetchCount() {
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.item_count; })
      .catch(function () { return null; });
  }

  function fallbackToast(item, count) {
    var el = document.getElementById('RfQaToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'RfQaToast';
      el.className = 'rf-cart-toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    var title = (item && (item.product_title || item.title)) || 'Item';
    el.innerHTML = '<p class="rf-cart-toast__label">✓ Added to your cart</p><p style="margin:0">' + title.replace(/</g, '&lt;') + '</p>' +
      '<div class="rf-cart-toast__actions"><a class="rf-cart-toast__btn" href="' + cartUrl + '">View cart' + (count ? ' (' + count + ')' : '') + '</a></div>';
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 6000);
  }

  function showError(wrap, msg) {
    if (!wrap) return;
    var err = wrap.querySelector('.rf-qa__error');
    if (!err) {
      err = document.createElement('p');
      err.className = 'rf-qa__error';
      wrap.appendChild(err);
    }
    err.textContent = msg || 'Sorry, that could not be added. Please try again.';
    setTimeout(function () { if (err.parentNode) err.parentNode.removeChild(err); }, 5000);
  }

  function qtyOf(wrap) {
    var input = wrap.querySelector('.rf-qa__input');
    var q = input ? parseInt(input.value, 10) : 1;
    if (!q || q < 1) q = 1;
    if (q > 99) q = 99;
    if (input) input.value = q;
    return q;
  }

  function add(btn) {
    var wrap = btn.closest('[data-rf-qa]');
    var id = btn.getAttribute('data-rf-add') || (wrap && wrap.getAttribute('data-selected'));
    if (!id || btn.classList.contains('is-loading')) return;
    var qty = wrap ? qtyOf(wrap) : 1;
    btn.classList.add('is-loading');
    btn.setAttribute('aria-disabled', 'true');

    var body = new FormData();
    body.append('id', id);
    body.append('quantity', String(qty));
    body.append('sections', 'cart-bubble');

    fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          showError(wrap, res.description || res.message);
          return;
        }
        var count = null;
        try {
          var m = String((res.sections && res.sections['cart-bubble']) || '').match(/\d+/);
          if (m) count = m[0];
        } catch (e) {}
        var done = function (c) {
          updateCount(c);
          if (typeof window.rfShowCartToast === 'function') window.rfShowCartToast(res, c);
          else fallbackToast(res, c);
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
          var input = wrap && wrap.querySelector('.rf-qa__input');
          if (input) input.value = 1;
        };
        if (count === null) fetchCount().then(done); else done(count);
      })
      .catch(function () { showError(wrap); })
      .finally(function () {
        btn.classList.remove('is-loading');
        btn.removeAttribute('aria-disabled');
      });
  }

  document.addEventListener('click', function (e) {
    var size = e.target.closest('[data-rf-size]');
    if (size) {
      e.preventDefault(); e.stopPropagation();
      var wrap = size.closest('[data-rf-qa]');
      wrap.setAttribute('data-selected', size.getAttribute('data-rf-size'));
      wrap.querySelectorAll('[data-rf-size]').forEach(function (b) { b.setAttribute('aria-pressed', b === size ? 'true' : 'false'); });
      return;
    }
    var step = e.target.closest('[data-rf-step]');
    if (step) {
      e.preventDefault(); e.stopPropagation();
      var w = step.closest('[data-rf-qa]');
      var input = w.querySelector('.rf-qa__input');
      var q = (parseInt(input.value, 10) || 1) + parseInt(step.getAttribute('data-rf-step'), 10);
      input.value = Math.min(99, Math.max(1, q));
      return;
    }
    var btn = e.target.closest('[data-rf-add]');
    if (btn) {
      e.preventDefault(); e.stopPropagation();
      add(btn);
    }
  });

  // Keep clicks and typing in the quantity box from triggering the card link.
  document.addEventListener('click', function (e) {
    if (e.target.closest('.rf-qa__input')) { e.preventDefault(); e.stopPropagation(); e.target.focus(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.closest('.rf-qa__input')) {
      e.preventDefault();
      var w = e.target.closest('[data-rf-qa]');
      var b = w && w.querySelector('[data-rf-add]');
      if (b) add(b);
    }
  });
})();
